'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _CardBankController() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_CardController, _BankController];

  this.bankAccountModelInitialized = $.Deferred();
  this.recurringTransferModelInitialized = $.Deferred();
  this._recurringTransferIndexAction = 'cards.index_recurring_transfer';
  this.spendingBankAccount = null;

  this.init = function () {
    this._super();
    $.when(this._currentCardDataInitialized).then(this.loadMoneyRoutingGuard.bind(this));
    $.when(this._currentCardDataInitialized).then(this._checkForRecurringTransferModel.bind(this));

    this.getCardBankAccount();
  };

  // get card bank account and related bank info
  this.getCardBankAccount = function () {
    var _this = this;

    this.getFinancialAccounts(function () {
      var bankId = _this.getVisaDirectAccountBankId();
      if (bankId) {
        _this.getBankById(bankId, function () {
          this.bankAccountModelInitialized.resolve();
        });
      } else {
        _this.getBankList();
        _this.bankAccountModelInitialized.resolve();
      }
    });
  };

  this.showBankLogo = function () {
    var bankIcon = [].concat(_toConsumableArray(this.node.getElementsByClassName('js--bankicon')));
    if (bankIcon) {
      var bankId = this.getVisaDirectAccountBankId(this.getVisaDirectAccount());
      if (bankId) {
        this.getBankById(bankId, function (bank) {
          bankIcon.forEach(function (element) {
            element.setAttribute('src', bank.getBankImg());
          });
        });
      } else {
        bankIcon.forEach(function (element) {
          element.setAttribute('src', '/member/assets/imgs/bank-icons/Generic-Bank.png');
        });
      }
    }
  };

  this._checkForRecurringTransferModel = function () {
    // setup recurring transfer model
    if (!this.presenter.getModelProperty('card.recurringTransfer') || !this.presenter.models.card.recurringTransfer._initialized) {
      // No recurring transfer model
      this._initRecurringTransferIndexDataCallback = this.presenter.addCallbackToAction(this._recurringTransferIndexAction, this._initRecurringTransfersIndexData.bind(this));
      // Create recurring transfer model
      if (!this.presenter.getModelProperty('card.recurringTransfer')) {
        if (this.presenter.hasAction(this._recurringTransferIndexAction)) {
          this.presenter.performAction(this._recurringTransferIndexAction, null);
        } else {
          // Redirect
          this._hist.replaceUrl('/member/dashboard/home');
        }
      }
    } else {
      this.recurringTransferModelInitialized.resolve();
    }
  };

  this._initRecurringTransfersIndexData = function (data, response) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (!this._errorInitialized) {
        this._errorInitialized = true;
        this.invokeConnectionIssuePage({ action: this._recurringTransferIndexAction }, { productLabel: 'MogoCard' }, null, this._connectionIssueConfig);
      }
    } else if (response === 200) {
      this.presenter.createModel('card.recurringTransfer', { data: data });
      this.recurringTransferModelInitialized.resolve();
      this._errorInitialized = false;
    }
  };

  this.getVisaDirectAccount = function () {
    return this.presenter.getModelProperty('banking.financial_accounts.visa_direct_financial_accounts.0');
  };

  this.getVisaDirectAccountNumber = function (account, maskChar) {
    if (account) {
      var maskBlob = maskChar + maskChar + maskChar + maskChar;
      return maskBlob + ' ' + maskBlob + ' ' + maskBlob + ' ' + account.last_four_digits;
    }
  };

  this.getVisaDirectAccountBankId = function (account) {
    if (account) {
      return account.bank_id;
    }
  };

  this.getVisaDirectAccountBankName = function (account) {
    if (account) {
      return account.issuer_name;
    }
  };

  this.getVisaDirectAccountName = function (account) {
    if (account) {
      return (this.getVisaDirectAccountBankName(account) + ' ' + account.brand + ' ' + account.funding_type).replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }
  };

  // still need to call getFinancialAccounts() since these might be called before
  // the getFinancialAccounts() call in init() has returned.
  this.goToTransferIfCardAdded = function () {
    var _this2 = this;

    this.getFinancialAccounts(function (accts) {
      if (accts && accts.length > 0) {
        if (window.location.pathname.includes(_this2.paths.card.settings)) {
          _this2._hist.replaceUrl(_this2.paths.card.settings);
        } else {
          _this2._hist.replaceUrl(_this2.paths.card.load_card.vdtransfer);
        }
      }
      return true;
    });
  };

  this.goToSelectBankIfNoCard = function () {
    var _this3 = this;

    this.getFinancialAccounts(function (accts) {
      if (!accts || accts.length === 0) {
        if (window.location.pathname.includes(_this3.paths.card.settings)) {
          _this3._hist.replaceUrl(_this3.paths.card.settings_load_card.select_bank);
        } else {
          _this3._hist.replaceUrl(_this3.paths.card.load_card.select_bank);
        }
        return true;
      }
    });
  };

  this.goToTransferIfNewLoad = function () {
    var loadCardAmount = this.presenter.getModelProperty('card.card_load.load_card_amount');
    var loadCardFreq = this.presenter.getModelProperty('card.card_load.load_card_frequency');
    var editMode = window.location.pathname.includes('/card/edit/');

    if (!loadCardAmount || !loadCardFreq) {
      if (editMode) {
        this._hist.replaceUrl(this.paths.card.load_card.edit_vdtransfer);
      } else {
        this._hist.replaceUrl(this.paths.card.load_card.vdtransfer);
      }
      return true;
    }
  };

  this.loadMoneyRoutingGuard = function () {
    var currentPath = window.location.pathname;
    if ((currentPath.includes(this.paths.card.settings + '/') || currentPath.includes(this.paths.card.load_card.select_bank)) && !this.hasActiveCard()) {
      this._hist.replaceUrl(this.paths.card.dashboard);
    }
  };

  // Format upcoming auto-transfer date
  this.formatDateFromNow = function (date) {
    var allowPast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var now = moment().format('YYYY-MM-DD');
    var next = moment(date);
    var diff = next.diff(now, 'days');

    if (diff > 0) {
      return 'in ' + diff + ' day' + (diff > 1 ? 's' : '');
    }
    if (diff === 0) {
      return 'is today';
    }
    if (allowPast) {
      return diff + ' day' + (diff < -1 ? 's' : '') + ' ago';
    }
    return '';
  };

  // Load Card Errors
  this.validateAmountTransactionLimits = function (amount, errorInput) {
    // NOTE using card.card_fis_limits as card_limits is being deprecated as per BE
    var _presenter$getModelPr = this.presenter.getModelProperty('card.card_fis_limits'),
        min_load_amount = _presenter$getModelPr.min_load_amount,
        card_daily_load_limit = _presenter$getModelPr.card_daily_load_limit,
        max_load_amount = _presenter$getModelPr.max_load_amount,
        freq_amt_available = _presenter$getModelPr.freq_amt_available;

    var formatMoney = function formatMoney(data) {
      return '$' + data.toLocaleString('en');
    };
    var errorMessages = {
      minLoadLimit: 'Hold up! The minimum transfer amount is ' + formatMoney(min_load_amount) + '.',
      maxLoadLimit: 'Hey big spender! The maximum transfer amount is ' + formatMoney(max_load_amount) + '.',
      dailyLoadLimit: 'This transfer puts you over the ' + formatMoney(card_daily_load_limit) + ' daily limit. Choose an amount up to ' + formatMoney(freq_amt_available) + '.'
    };

    var errorMsg = '';
    var failedReason = '';
    var isValid = true;

    // per transaction min checking
    if (amount < min_load_amount) {
      isValid = false;
      errorMsg = errorMessages.minLoadLimit;
      failedReason = 'Min Transfer Amount';

      // card max load amount
    } else if (amount > max_load_amount) {
      isValid = false;
      errorMsg = errorMessages.maxLoadLimit;
      failedReason = 'Max Transfer Amount';

      // per transaction max checking
    } else if (amount > card_daily_load_limit) {
      isValid = false;
      errorMsg = errorMessages.dailyLoadLimit;
      failedReason = 'Daily Limit';
    }

    if (!isValid) {
      errorInput.mogo().setError(true, errorMsg);
      errorInput.mogo().showErrorLabel();
      this.pushCardLoadValidationErrorAnalytics(failedReason);
    }

    return isValid;
  };

  this.validateAmountAdhocLimits = function (amount) {
    var errorInput = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var errorBanner = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var _presenter$getModelPr2 = this.presenter.getModelProperty('card.card_fis_limits'),
        max_load_amount = _presenter$getModelPr2.max_load_amount,
        freq_amt_available = _presenter$getModelPr2.freq_amt_available,
        max_load_amount_set_by = _presenter$getModelPr2.max_load_amount_set_by,
        card_daily_load_limit = _presenter$getModelPr2.card_daily_load_limit,
        card_balance_limit = _presenter$getModelPr2.card_balance_limit,
        auth_bal = _presenter$getModelPr2.auth_bal;

    var formatMoney = function formatMoney(data) {
      return '$' + data.toLocaleString('en');
    };
    var errorMessages = {
      maxBankBalanceLimit: 'Whoa! You don\'t have enough money for that transfer in your bank account. Choose an amount up to ' + formatMoney(max_load_amount) + '.',
      maxBalanceLimit: 'Whoa! This transfer puts you over the ' + formatMoney(card_balance_limit) + ' limit. Choose an amount up to ' + formatMoney(card_balance_limit - auth_bal) + '.',
      dailyLoadLimit: 'This transfer puts you over the ' + formatMoney(card_daily_load_limit) + ' daily limit. Choose an amount up to ' + formatMoney(freq_amt_available) + '.',
      singleLoadLimit: 'Hey big spender! The maximum transfer amount is ' + formatMoney(card_daily_load_limit) + '.'
    };

    var errorTitle = null;
    var errorMsg = null;
    var failedReason = null;
    var isValid = true;

    // Bank Balance Limit
    // if (amount > max_load_amount && max_load_amount_set_by === 'BANK_BALANCE') {
    //   isValid = false;
    //   errorMsg = errorMessages.maxBankBalanceLimit;
    //   failedReason = 'Exceeds Bank Balance Limit';

    // Single Transaction FIS Limit
    // if (amount > max_load_amount && max_load_amount_set_by === 'FIS') {
    if (amount > card_daily_load_limit && max_load_amount_set_by !== 'FIS_CARD_BALANCE_LIMIT') {
      isValid = false;
      errorMsg = errorMessages.singleLoadLimit;
      failedReason = 'Single Transaction Limit';

      // Card Balance Limit
      // first part is for when max_load_amount is working correctly, second part is a stop-gap to clear QA
    } else if (amount > max_load_amount && max_load_amount_set_by === 'FIS_CARD_BALANCE_LIMIT' || amount > card_balance_limit - auth_bal) {
      isValid = false;
      errorMsg = errorMessages.maxBalanceLimit;
      failedReason = 'Exceeds Card Balance Limit';

      // 24hr Rolling Limit
    } else if (amount > freq_amt_available) {
      isValid = false;
      errorMsg = errorMessages.dailyLoadLimit;
      failedReason = 'Daily Limit';
    }

    if (!isValid) {
      if (errorInput) {
        errorInput.mogo().setError(true, errorMsg);
        errorInput.mogo().showErrorLabel();
      } else {
        errorTitle = errorTitle;
        if (errorBanner.mogo().create) {
          errorBanner.mogo().create('MessageBanner', {
            type: 'warning',
            title: errorTitle,
            msg: errorMsg
          });
        } else {
          errorBanner.mogo().updateContent(errorTitle, errorMsg);
        }
        errorBanner.mogo().show();
      }
      this.pushCardLoadValidationErrorAnalytics(failedReason);
    }

    return isValid;
  };

  this.validateAmountRecurringLimits = function (amount) {
    var errorBanner = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var _presenter$getModelPr3 = this.presenter.getModelProperty('card.card_fis_limits'),
        freq_amt_available = _presenter$getModelPr3.freq_amt_available,
        card_daily_load_limit = _presenter$getModelPr3.card_daily_load_limit;

    var formatMoney = function formatMoney(data) {
      return '$' + data.toLocaleString('en');
    };
    var errorMessages = {
      // maxBalanceLimitRecurring: `Transferring ${formatMoney(amount)} now would take you over the ${formatMoney(card_balance_limit)} balance limit.
      //   Change the amount or pick a later day for your next transfer, but you need to spend ${formatMoney(amount - max_load_amount)} before then or you'll run into the same issue.`,
      dailyLoadLimitRecurring: 'Transferring ' + formatMoney(amount) + ' tomorrow will take you over your ' + formatMoney(card_daily_load_limit) + ' daily transfer limit. You can either select a later date, or lower your transfer amount to ' + formatMoney(freq_amt_available) + ' or less.'
    };

    var errorTitle = null;
    var errorMsg = null;
    var failedReason = null;
    var isValid = true;

    // 24hr Rolling Limit
    if (amount > freq_amt_available) {
      isValid = false;
      errorMsg = errorMessages.dailyLoadLimitRecurring;
      failedReason = 'Daily Limit';
    }

    if (!isValid) {
      if (errorBanner.mogo().create) {
        errorBanner.mogo().create('MessageBanner', {
          type: 'warning',
          title: 'Hold Up',
          msg: errorMsg
        });
      } else {
        errorBanner.mogo().updateContent(errorTitle, errorMsg);
      }

      errorBanner.mogo().show();
      this.pushCardLoadValidationErrorAnalytics(failedReason);
    }

    return isValid;
  };

  this.pushCardLoadValidationErrorAnalytics = function (failedReason) {
    var formErrorPayload = { FormErrors: ['amount'] };
    if (failedReason) formErrorPayload.ErrorNotificationContent = [failedReason];
    this.analytics.forcePushEvent('form-errors', formErrorPayload);
  };

  this.pushNotificationAnalytics = function (content) {
    this.analytics.forcePushEvent('error-notification', {
      errorNotificationProduct: ['MogoCard'],
      errorNotificationContent: [content]
    });
  };

  this.initAllReady = function () {
    this._super();
  };

  this.destroy = function () {
    this._super();
  };
}